export const listProducts = `
   query listProducts($filter: ProductsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listProducts(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              name
              shortDescription
              longDescription
              productImage
              status
              freeTrial
              createdByUsername
              created
              updated
           }
           nextToken
       }
   }
`;


export const getProduct = `
   query getProduct($id:ID!) {
          getProduct(id:$id) {
            id
            name
            shortDescription
            longDescription
            status
            createdByUsername
            created
            updated
         }
}`